import { useStyletron } from "baseui";
import { HeadingMedium, HeadingXLarge, ParagraphLarge } from "baseui/typography";
import React from "react";
import { DocsInterface, type DocsInterfaceProps } from "../../../../../../src/chrome/DocsInterface";
import { colors, SplashCard, SplashCardGrid, SplashContentContainer } from "../../../../../../src/components/SplashPage";
import { DocLink } from "../../../../../../src/markdown-components";
import { ShopifyWebhookIcon } from "@gadgetinc/widgets/src/icons/ShopifyWebhookIcon";

const ConnectionQuickstarts = (props: DocsInterfaceProps) => {
  const [_css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>Connecting to Shopify</HeadingXLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
          }}
        >
          Learn how to set up different Shopify connections that automatically take care of OAuth, webhook subscriptions, frontend sessions,
          <DocLink href="/guides/plugins/shopify#shopify"> and more</DocLink>.
        </ParagraphLarge>
        <SplashCard
          icon={<ShopifyWebhookIcon $size={32} />}
          title="Quickstart: Connect to Shopify"
          color={colors.blue}
          body="Learn how to set up a Shopify connection. This is our recommended way to set up a connection."
          href="/guides/plugins/shopify/quickstarts/shopify-quickstart"
          copy="Get started →"
        />
        <br />
        <br />
        <HeadingMedium>Other ways to connect</HeadingMedium>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
          }}
        >
          You can also manually connect to a Shopify application in the Dev Dashboard, or connect directly to a Shopify store.
        </ParagraphLarge>
        <SplashCardGrid $maxColumns={2}>
          <SplashCard
            title="Connect to the Dev Dashboard manually"
            color={colors.white}
            body="Learn how to set up a Shopify connection with an application created in Shopify's Dev Dashboard."
            href="/guides/plugins/shopify/quickstarts/partners-quickstart"
            copy="Get started →"
          />
          <SplashCard
            title="Connect to a store admin"
            color={colors.white}
            body="Learn how to connect directly to a Shopify store."
            href="/guides/plugins/shopify/quickstarts/admin-quickstart"
            copy="Get started →"
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default ConnectionQuickstarts;
